export default __webpack_public_path__ + "static/media/Vydehi.c88fcbe4.png";